import { Component, input, computed } from '@angular/core';
import { Image, ResizeHtmlImagesPipe } from '@teamfoster/sdk/image';

import { StripEmbedPipe } from '@teamfoster/sdk/cookie-ngrx';
import { SafePipe } from '@teamfoster/sdk/text-utility';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  imports: [ResizeHtmlImagesPipe, StripEmbedPipe, SafePipe],
})
export class HeaderComponent {
  title = input<string>();
  subTitle = input<string | null>();
  intro = input<string | null>();
  image = input<Image | null>();

  theme = input<'accent' | 'secondary'>('accent');

  cleanIntro = computed(() => {
    const intro = this.intro();

    // remove all <p><br></p> from intro
    return intro?.replace(/<p><br><\/p>/g, '');
  });
}
